import _ from 'lodash'

import i18n from '@/i18n/i18n'
import { RoleService } from '@/services/admin/RoleService'
import { build_query } from '@/utilities/helpers'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = ['name', 'by_name_label']

export const state = {
  roles: [],
  role: {},
  meta: null,
  permissions: [],
  unselectedPermissions: []
}

export const mutations = {
  SET_ROLES(state, roles) {
    state.roles = roles.data
    state.meta = roles.meta
  },
  SET_ROLE(state, role) {
    state.role = role
  },
  ADD_ROLE(state, role) {
    state.roles.push(role)
  },
  DELETE_ROLE(state, roleToRemove) {
    state.roles = state.roles.filter(role => {
      return role.id !== roleToRemove.id
    })
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
  },
  SET_UNSELECTED_PERMISSIONS(state, params) {
    state.unselectedPermissions = _.filter(params.all, function (permission) {
      return _.findIndex(params.permissions, { id: permission.id }) === -1
    })
  },
  DELETE_PERMISSION(state, permissionToRemove) {
    state.permissions = state.permissions.filter(permission => {
      return permission.id !== permissionToRemove.id
    })
  }
}

export const actions = {
  getRoles({ commit }, query) {
    let newQuery = build_query(query, allowedFilters)

    return new Promise((resolve, reject) => {
      let roleService = new RoleService(newQuery)
      roleService.getRoles().then(response => {
        commit('SET_ROLES', response)
        resolve(response.data)
      })
    })
  },
  getRole({ commit }, id) {
    return new Promise(resolve => {
      let roleService = new RoleService()
      roleService.getRole(id).then(response => {
        commit('SET_ROLE', response.data)
        resolve(response.data)
      })
    })
  },
  createRole({ commit, dispatch }, role) {
    return new Promise(resolve => {
      let roleService = new RoleService()
      roleService.createRole(role).then(response => {
        const notification = {
          type: 'success',
          message: t('store.admin.role.role_created')
        }
        dispatch('notification/add', notification, {
          root: true
        })
        commit('ADD_ROLE', response.data)
        resolve(response.data)
      })
    })
  },
  updateRole({ state, dispatch }, role) {
    return new Promise(resolve => {
      let roleService = new RoleService()
      roleService.updateRole(state.role.id, role).then(response => {
        const notification = {
          type: 'success',
          message: t('store.admin.role.role_updated')
        }
        dispatch('notification/add', notification, {
          root: true
        })
        resolve(response.data)
      })
    })
  },
  destroyRole({ commit, dispatch }, params) {
    return new Promise(resolve => {
      let roleService = new RoleService()
      roleService.destroyRole(params.id).then(response => {
        commit('DELETE_ROLE', params)
        const notification = {
          type: 'warning',
          message: t('store.admin.role.role_deleted')
        }
        dispatch('notification/add', notification, {
          root: true
        })
        resolve(response.data)
      })
    })
  },
  getPermissions({ commit, rootState }, id) {
    return new Promise(resolve => {
      let roleService = new RoleService()
      roleService.getPermissions(id).then(response => {
        commit('SET_PERMISSIONS', response.data)
        commit('SET_UNSELECTED_PERMISSIONS', {
          permissions: response.data,
          all: rootState.adminPermission.permissions
        })
        resolve(response.data)
      })
    })
  },
  attachPermissions({ commit, dispatch, state }, permissions) {
    return new Promise(resolve => {
      let roleService = new RoleService()
      roleService.attachPermissions(state.role.id, permissions).then(response => {
        const notification = {
          type: 'success',
          message: t('store.admin.role.permissions_added')
        }
        dispatch('notification/add', notification, {
          root: true
        })
        commit('SET_PERMISSIONS', response.data)
        resolve(response.data)
      })
    })
  },
  detachPermission({ commit, dispatch, state }, params) {
    return new Promise(resolve => {
      let roleService = new RoleService()
      roleService.detachPermission(state.role.id, params.id).then(response => {
        const notification = {
          type: 'warning',
          message: t('store.admin.role.role_deleted')
        }
        dispatch('notification/add', notification, {
          root: true
        })
        commit('DELETE_PERMISSION', params)
        resolve(response.data)
      })
    })
  }
}
